export enum ETypeOfDialog {
	ADD = 'add',
	EDIT = 'edit',
}
